// @flow

import React from 'react'
import OrderTestsLayout from '../components/Layout'
import Header from '../components/Header'
import TestsTable from '../components/TestsTable'
import OrderTestsManager from './OrderTestsManager'

import { OrderTestsOperation } from 'hfty-operator-order-tests/types'

// Types
type Props = {
  jobsForOrderTests: Array<Object>,
  fields: Array<Object>,
  operation: OrderTestsOperation,
  currentUser: Object,
  actions: {
    onCancelOperation: Function,
    onChangeOperation: Function,
    onSubmitOperation: Function,
    createOrder: Function,
    updateUserBillingInfo: Function,
  },
}

/**
 * Using Layout component with ability to pass data and callbacks
 * to child components
 * */
export class OrderTests extends React.Component {
  props: Props
  state = {
    selectedTestsIds: Array,
  }

  constructor(props: Object) {
    super(props)

    this.state = {
      selectedTestsIds: [],
    }
  }

  render(): React.Element<any> {
    return (
      <OrderTestsLayout
        header={<Header />}
        table={
          <TestsTable
            jobs={this.props.jobsForOrderTests}
            fields={this.props.fields}
            currentUser={this.props.currentUser}
            operation={this.props.operation}
            onSubmit={this.props.actions.onSubmitOperation}
            onCancel={this.props.actions.onCancelOperation}
            onChange={this.props.actions.onChangeOperation}
            updateUserBillingInfo={this.props.actions.updateUserBillingInfo}
            createOrder={this.props.actions.createOrder}
          />
        }
      />
    )
  }
}

export default OrderTestsManager(OrderTests)
